import(/* webpackMode: "eager" */ "/codebuild/output/src955237198/src/esimify/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewGrid"] */ "/codebuild/output/src955237198/src/esimify/src/app/[lang]/sections/reviews.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src955237198/src/esimify/src/components/layout/footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src955237198/src/esimify/src/components/layout/navigation/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src955237198/src/esimify/src/i18n/translation-provider.tsx");
